/* eslint-disable max-len */
import React from 'react';

const Privacy = () => {
	return (
		<div>
			<div>Sensitive data like IP addresses, location etc is never stored with us.</div>
			<br />
			<h4>Google Analytics</h4>
			<div>Use to store basic <a href="https://support.google.com/analytics/answer/6004245?ref_topic=2919631" target="_blank" rel="noopener noreferrer"> visit data</a>.</div>
			<br />
			<h4>Image compression details for analytics</h4>
			<div>Filename, compression level, files sizes before & after compression, time taken, date & time.</div>
			<br />
			<h4>Files stored on server are deleted every few hours automatically.</h4>
		</div>
	);
};

export default Privacy;



// WEBPACK FOOTER //
// ./src/components/Privacy.js